export default __webpack_public_path__ + "static/media/blogmodalimg1.fad41713.jfif";